import Axios from 'axios';
import { BACKEND_URL } from '@/utils/constants';
import { notify } from '@/utils/notify';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import React from 'react';
import AlertIcon from '@/components/Notifications/AlertIcon';

export const ApiRequest = Axios.create({
    baseURL: BACKEND_URL + 'api/',
});

export const errors: { [key: string]: string } = {
    ERR_ITEMS_LIMIT: 'You cant add more than 15 items to your bet',
    ERR_AMOUNT_TOOLESS: 'Amount of the bet is less than the minimum possible',
    ERR_NO_GAME: 'Game is not exists',
    ERR_AMOUNT_TOOMUCH: 'The second player can not make a bet very different from the first player',
    ERR_GAME_FINISHED: 'Game in the winner selection status',
    ERR_GAME_PAUSED: 'The game is paused',
    ERR_PROMOCODE_NOTFOUND: 'Promocode not found',
    ERR_PROMOCODE_ACTIVATED: "You can't activate the promocode more than 1 time!",
    'You are banned': 'You are banned',
    'Chat is closed for maintenance': 'Chat is closed for maintenance',
    'You have sent too many trade offers, or have too many outstanding trade offers with retarded person. Please cancel some before sending more.':
        'You have sent too many trade offers, or have too many outstanding trade offers with retarded person. Please cancel some before sending more.',
};

ApiRequest.interceptors.response.use(
    (response) => response,
    (err) => {
        const code = err.code;

        const message: any = err?.response?.data?.message;

        if (
            err &&
            message != 'Forbidden resource' &&
            message != 'Request failed with status code 401'
        ) {
            notify(
                'error',
                <AlertIcon />,
                <NotifyWrapper
                    title={'Error'}
                    text={errors[code] || errors[message] || message || 'Error'}
                />
            );
        }
    }
);

export default { ApiRequest };
